// Books list.
// To add a new book, append an object to this array. Fields:
//   title       - book title (string, required)
//   author      - author name(s) (string)
//   description - one-line summary (string)
//   status      - status label shown in brackets, e.g. "Completed" or "....." (in-progress)
//   isReading   - true = currently reading (renders red status + a [Reading] tag)
// Array order = display order. The count on the page is booksData.length.

export const booksData = [
  {
    title: "Crime and Punishment",
    author: "Fyodor Dostoevsky",
    description: "A psychological exploration of morality and redemption.",
    status: ".....",
    isReading: true,
  },
  {
    title: "The Metamorphosis",
    author: "Franz Kafka",
    description: "A surreal story of a man who transforms into a giant insect.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "the Life Of a Stupid man",
    author: "Ryunosuke Akutagawa",
    description: "A short story about the life of a foolish man. A brief, haunting look into a man's final days.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "The Stranger",
    author: "Albert Camus",
    description: "A philosophical novel about absurdism and existentialism.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "1984",
    author: "George Orwell",
    description:
      "A dystopian novel set in a totalitarian society under constant surveillance.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "The Courage to Be Disliked",
    author: "Ichiro Kishimi and Fumitake Koga",
    description: "A self-help book based on Adlerian psychology.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "Three Days of Happiness",
    author: "Sugaru Miaki",
    description:
      "A story about selling your lifespan for money and finding meaning in life.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "Norwegian Wood",
    author: "Haruki Murakami",
    description: "A nostalgic story of love and loss in 1960s Japan.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "The Subtle Art of Not Giving a F*ck",
    author: "Mark Manson",
    description: "A counterintuitive approach to living a good life.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "As a Man Thinketh",
    author: "James Allen",
    description: "A philosophical essay on the power of thought.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "Dopamine Detox",
    author: "Thibaut Meurisse",
    description: "A guide to overcoming distractions and regaining focus.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "Art of Living",
    author: "Epictetus",
    description: "A manual for living based on Stoic philosophy.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "Brave New World",
    author: "Aldous Huxley",
    description:
      "A dystopian novel exploring a technologically advanced society.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "Ikigai",
    author: "Héctor García and Francesc Miralles",
    description: "A guide to finding purpose and happiness in life.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "How to Win Friends and Influence People",
    author: "Dale Carnegie",
    description: "A classic book on interpersonal skills and communication.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "Man's Search for Meaning",
    author: "Viktor E. Frankl",
    description: "A memoir and exploration of finding meaning in suffering.",
    status: "Completed",
    isReading: false,
  },
  {
    title: "Deep Work",
    author: "Cal Newport",
    description:
      "A guide to achieving focused success in a distracted world.",
    status: "Completed",
    isReading: false,
  },
];
